import OneSignal from "react-onesignal";

import { env } from "@/env";

export const initializeOneSignal = async () => {
  const isDevelopment = process.env.NODE_ENV === "development";

  return await OneSignal.init({
    appId: env.NEXT_PUBLIC_ONE_SIGNAL_APP_ID,
    allowLocalhostAsSecureOrigin: isDevelopment,
    notificationClickHandlerMatch: "origin",
    notificationClickHandlerAction: "focus",
  });
};
